import { Button, Spinner } from "@material-tailwind/react";
import React, { useEffect, useState } from "react";
import { getOneReportDetailsApi } from "api/gestionStock";

import { ToastContainer, toast } from "react-toastify";
import { updateReportDataApi, updateFCreatedTApi, fixMgReportNumbersApi } from "api/gestionStock";
import { getAllProductsApi } from "api/products";
import { getAllStockEntryByLotNumberApi } from "api/stockEntry";
import { FaPlusCircle, FaTrash } from "react-icons/fa";

function StockInfo({ selectedReportId, popupHandler, showToast, accessList }) {
  const [reportDetails, setReportDetails] = useState({});
  const [reportCategories, setReportCategories] = useState([]);

  const [inputValues, setInputValues] = useState([]);

  const [productStockList, setProductStockList] = useState([]);
  const [productLotNumbersData, setProductLotNumbersData] = useState({}); // Store full stock entry data by product code

  const [isLoading, setIsLoading] = useState(false);

  const generateAllocationId = () =>
    typeof crypto !== "undefined" && crypto.randomUUID
      ? crypto.randomUUID()
      : `${Date.now()}-${Math.random()}`;

  const createAllocationEntry = () => ({
    id: generateAllocationId(),
    lotNumber: "",
    city: "",
    inputQuantity: "",
  });

  const getTotalDisponibleForLot = (stockEntry) => {
    if (
      !stockEntry ||
      !stockEntry.ProductDetails ||
      !stockEntry.ProductDetails[0] ||
      !Array.isArray(stockEntry.ProductDetails[0].Stock)
    ) {
      return 0;
    }
    return stockEntry.ProductDetails[0].Stock.reduce(
      (sum, depot) => sum + (parseFloat(depot?.Disponible) || 0),
      0
    );
  };

  const filterStockEntriesWithAvailableQty = (entries = []) =>
    entries.filter((entry) => getTotalDisponibleForLot(entry) > 0);

  useEffect(() => {
    getReportDetails(selectedReportId);
  }, [selectedReportId]);

  const hadleShowToast = (type, message) => {
    if (type === "success") {
      popupHandler('reload')

      toast.success(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    if (type === "error") {
      toast.error(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };

  // const handleStockValidation = async () => {
  //   try {
  //     const errosList = []
  //     const selectedStock = []

  //     // check the quantities is same
  //     inputValues.map(el => {
  //       if(el.quantiteByUnity != el.inputQuantity) {
  //         errosList.push(`Quantité demandée et Quantité sortie ne sont pas les mêmes (${el.productName})`)
  //       }
  //     })

  //     if(errosList.length !== 0)
  //       return hadleShowToast('error', errosList[0])

  //     // check if stock selected
  //     inputValues.map(el => {
  //       if(el.city == "")
  //         errosList.push(`Selectionner le stock pour ${el.productName}`)
  //     })

  //     if(errosList.length !== 0)
  //       return hadleShowToast('error', errosList[0])

  //     // check if stock is available
  //     inputValues.map(el => {
  //         const selectedDepot = el.Stock.find(el2 => el2.City === el.city)

  //         if(parseFloat(el.quantiteByUnity) > parseFloat(selectedDepot.Disponible))
  //           errosList.push(`stock insifusant pour le produit ${el.productName}`)
  //     })

  //     if(errosList.length !== 0)
  //       return hadleShowToast('error', errosList[0])

  //     inputValues.map(el => {
  //       selectedStock.push({
  //         productName: el.productName,
  //         city: el.city,
  //         unity: el.unity,
  //         quantity: el.quantiteByUnity,
  //         Code: el.Code
  //       })
  //     })

  //     const uniqueDepot = [...new Set(selectedStock.map(obj => obj.city))];

  //     const updatedObject = {
  //       NumberOfBls: uniqueDepot.length,
  //       EtatBonLivraison: "V",
  //       EtatMagasinier: "V",
  //       MagasinStock: selectedStock,
  //     };

  //     await updateReportDataApi(selectedReportId, updatedObject)
  //     await updateFCreatedTApi(selectedReportId)

  //     hadleShowToast('success', 'Ajoutée')
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };

  const handleStockValidation = async () => {
    if (!accessList?.Validation) return;
    try {
      setIsLoading(true);

      const errosList = [];
      const selectedStock = [];

      // Validate per product quantities and required fields
      inputValues.forEach((product) => {
        const demandedQuantity = parseFloat(product.quantiteByUnity) || 0;
        const totalOutput = product.allocations.reduce(
          (sum, allocation) => sum + (parseFloat(allocation.inputQuantity) || 0),
          0
        );

        if (Math.abs(totalOutput - demandedQuantity) > 0.0001) {
          errosList.push(
            `Quantité demandée et Quantité sortie ne sont pas les mêmes (${product.productName})`
          );
        }

        product.allocations.forEach((allocation) => {
          if (!allocation.lotNumber || allocation.lotNumber === "all") {
            errosList.push(
              `Sélectionner le numéro de lot pour ${product.productName}`
            );
          }
          if (!allocation.city || allocation.city === "") {
            errosList.push(
              `Sélectionner le stock pour ${product.productName}`
            );
          }
          if (!allocation.inputQuantity || parseFloat(allocation.inputQuantity) <= 0) {
            errosList.push(
              `Entrer une quantité valide pour ${product.productName}`
            );
          }
        });
      });

      if (errosList.length !== 0) return hadleShowToast("error", errosList[0]);

      // check if stock is available
      if (reportDetails.ModeOperation !== "Avoir") {
        inputValues.forEach((product) => {
          product.allocations.forEach((allocation) => {
            const allocationQty = parseFloat(allocation.inputQuantity) || 0;
            let selectedDepot = null;

            if (allocation.lotNumber && allocation.lotNumber !== "all") {
              const stockEntry = productLotNumbersData[product.Code]?.find(
                (entry) => entry.LotNumber === allocation.lotNumber
              );
              if (
                stockEntry &&
                stockEntry.ProductDetails &&
                stockEntry.ProductDetails[0] &&
                stockEntry.ProductDetails[0].Stock
              ) {
                selectedDepot = stockEntry.ProductDetails[0].Stock.find(
                  (depot) => depot.City === allocation.city
                );
              }
            }

            if (!selectedDepot) {
              errosList.push(
                `Stock introuvable pour ${product.productName} au dépôt ${allocation.city}`
              );
            } else if (
              allocationQty > parseFloat(selectedDepot.Disponible || 0)
            ) {
              errosList.push(
                `stock insuffisant pour le produit ${product.productName} au dépôt ${allocation.city}`
              );
            }
          });
        });
      }

      if (errosList.length !== 0) return hadleShowToast("error", errosList[0]);

      inputValues.forEach((product) => {
        product.allocations.forEach((allocation) => {
          let lotNumberId = null;
          if (allocation.lotNumber) {
            const stockEntry = productLotNumbersData[product.Code]?.find(
              (entry) => entry.LotNumber === allocation.lotNumber
            );
            if (stockEntry && stockEntry._id) {
              lotNumberId = stockEntry._id.toString();
            }
          }

          selectedStock.push({
            productName: product.productName,
            city: allocation.city,
            lotNumber: allocation.lotNumber || "",
            lotNumberId: lotNumberId,
            unity: product.unity,
            quantity: parseFloat(allocation.inputQuantity) || 0,
            Code: product.Code,
          });
        });
      });

      const uniqueDepot = [...new Set(selectedStock.map((obj) => obj.city))];

      const updatedObject = {
        NumberOfBls: uniqueDepot.length,
        EtatBonLivraison: "V",
        EtatMagasinier: "V",
        MagasinStock: selectedStock,
      };

      await fixMgReportNumbersApi(selectedReportId);
      await updateReportDataApi(selectedReportId, updatedObject);
      await updateFCreatedTApi(selectedReportId);

      hadleShowToast("success", "Ajoutée");
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDepotInputChange = (productIndex, allocationIndex, city) => {
    setInputValues((prevInputValues) =>
      prevInputValues.map((product, idx) => {
        if (idx !== productIndex) return product;
        const allocations = product.allocations.map((allocation, allocIdx) =>
          allocIdx === allocationIndex ? { ...allocation, city } : allocation
        );
        return { ...product, allocations };
      })
    );
  };

  const handleLotNumberInputChange = (
    productIndex,
    allocationIndex,
    lotNumber
  ) => {
    setInputValues((prevInputValues) =>
      prevInputValues.map((product, idx) => {
        if (idx !== productIndex) return product;
        const allocations = product.allocations.map((allocation, allocIdx) =>
          allocIdx === allocationIndex
            ? { ...allocation, lotNumber, city: "" }
            : allocation
        );
        return { ...product, allocations };
      })
    );
  };

  const handleQuantityInputChange = (
    productIndex,
    allocationIndex,
    quantity
  ) => {
    setInputValues((prevInputValues) =>
      prevInputValues.map((product, idx) => {
        if (idx !== productIndex) return product;
        const allocations = product.allocations.map((allocation, allocIdx) =>
          allocIdx === allocationIndex
            ? { ...allocation, inputQuantity: quantity }
            : allocation
        );
        return { ...product, allocations };
      })
    );
  };

  const handleAddLotAllocation = (productIndex) => {
    setInputValues((prevInputValues) =>
      prevInputValues.map((product, idx) => {
        if (idx !== productIndex) return product;
        return {
          ...product,
          allocations: [...product.allocations, createAllocationEntry()],
        };
      })
    );
  };

  const handleRemoveLotAllocation = (productIndex, allocationIndex) => {
    setInputValues((prevInputValues) =>
      prevInputValues.map((product, idx) => {
        if (idx !== productIndex) return product;
        if (product.allocations.length === 1) {
          return product;
        }
        const allocations = product.allocations.filter(
          (_, allocIdx) => allocIdx !== allocationIndex
        );
        return { ...product, allocations };
      })
    );
  };

  const getReportDetails = async (reportID) => {
    try {
      const productsList = [];

      const reportDetails = await getOneReportDetailsApi(reportID);
      setReportDetails(reportDetails);

      const reportCategories = Object.getOwnPropertyNames(reportDetails.Rapport);
      setReportCategories(reportCategories);

      reportCategories.map((el, index) => {
        reportDetails.Rapport[el].produits.map(el2 => {
          productsList.push({
            productName: el2.name,
            unity: el2.unity,
            quantiteByUnity: el2.quantiteByUnity,
            Code: el2.Code,
            allocations: [createAllocationEntry()]
          });
        })
      });

      setInputValues(productsList)

      const productStockList = await getAllProductsApi("", "", "")
      setProductStockList(productStockList)

      // Fetch lot numbers for all products
      const lotNumbersDataMap = {};
      for (const product of productsList) {
        if (product.Code) {
          try {
            const lotNumbersRes = await getAllStockEntryByLotNumberApi(product.Code);
            const sortedEntries = [...lotNumbersRes].sort((a, b) => {
              if (!a.ExperationDate && !b.ExperationDate) return 0;
              if (!a.ExperationDate) return 1;
              if (!b.ExperationDate) return -1;
              return new Date(a.ExperationDate) - new Date(b.ExperationDate);
            });
            lotNumbersDataMap[product.Code] = filterStockEntriesWithAvailableQty(sortedEntries);
          } catch (err) {
            console.log(err);
            lotNumbersDataMap[product.Code] = [];
          }
        }
      }
      setProductLotNumbersData(lotNumbersDataMap);

    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div>
      <ToastContainer />
      <div
        className="mt-8 overflow-x-scroll xl:overflow-x-hidden"
        style={{
          overflow: "scroll",
          height: "80vh",
        }}
      >
        <table className="w-full">
          <thead>
            <tr>
              <th className="border-b border-gray-200 pr-20 pb-[10px] text-end dark:!border-navy-700">
                <p className="text-xs tracking-wide text-gray-600">Produit</p>
              </th>
              <th className="border-b border-gray-200 pr-20 pb-[10px] text-end dark:!border-navy-700">
                <p className="text-xs tracking-wide text-gray-600">Numéro de lot</p>
              </th>
              <th className="border-b border-gray-200 pr-20 pb-[10px] text-end dark:!border-navy-700">
                <p className="text-xs tracking-wide text-gray-600">Stock</p>
              </th>
              <th className="border-b border-gray-200 pr-20 pb-[10px] text-end dark:!border-navy-700">
                <p className="text-xs tracking-wide text-gray-600">
                  Quantité demandée
                </p>
              </th>
              <th className="border-b border-gray-200 pr-20 pb-[10px] text-end dark:!border-navy-700">
                <p className="text-xs tracking-wide text-gray-600">
                  Quantité sortie
                </p>
              </th>
              <th className="border-b border-gray-200 pr-20 pb-[10px] text-end dark:!border-navy-700">
                <p className="text-xs tracking-wide text-gray-600">Unité</p>
              </th>
            </tr>
          </thead>

          {inputValues[0] && (
            <tbody>
              {inputValues.map((product, productIndex) => {
                const allocationCount = product.allocations.length || 1;
                const totalOutput = product.allocations.reduce(
                  (sum, allocation) =>
                    sum + (parseFloat(allocation.inputQuantity) || 0),
                  0
                );

                return product.allocations.map((allocation, allocationIndex) => (
                  <tr key={`${product.Code}-${allocation.id}`}>
                    {allocationIndex === 0 && (
                      <td
                        className="pt-[14px] pb-[18px] sm:text-[14px]"
                        rowSpan={allocationCount}
                      >
                        <p className="text-sm font-bold text-navy-700">
                          {product.productName}
                        </p>
                      </td>
                    )}
                    <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                      <div className="flex items-center gap-2">
                        <select
                          className="flex w-full items-center justify-center rounded-xl border bg-white/0 p-2 text-sm outline-none"
                          onChange={(e) =>
                            handleLotNumberInputChange(
                              productIndex,
                              allocationIndex,
                              e.target.value
                            )
                          }
                          value={allocation.lotNumber || ""}
                        >
                          <option value="">Sélectionner le numéro de lot</option>
                          {(() => {
                            const stockEntries =
                              productLotNumbersData[product.Code] || [];
                            const sortedEntries = [...stockEntries]
                              .sort((a, b) => {
                                if (!a.ExperationDate && !b.ExperationDate)
                                  return 0;
                                if (!a.ExperationDate) return 1;
                                if (!b.ExperationDate) return -1;
                                return (
                                  new Date(a.ExperationDate) -
                                  new Date(b.ExperationDate)
                                );
                              })
                              .filter(
                                (entry) => getTotalDisponibleForLot(entry) > 0
                              );

                            return sortedEntries.map((stockEntry, lotIndex) => {
                              const sumOfDepots =
                                getTotalDisponibleForLot(stockEntry);
                              return (
                                <option
                                  key={`${stockEntry.LotNumber}-${lotIndex}`}
                                  value={stockEntry.LotNumber}
                                >
                                  {stockEntry.LotNumber} [
                                  {parseFloat(sumOfDepots).toFixed(2)}]
                                  {stockEntry.ExperationDate
                                    ? ` - Exp: ${new Date(
                                        stockEntry.ExperationDate
                                      ).toLocaleDateString()}`
                                    : ""}
                                </option>
                              );
                            });
                          })()}
                        </select>
                        {allocationIndex === allocationCount - 1 && (
                          <button
                            type="button"
                            className="text-green-600"
                            onClick={() => handleAddLotAllocation(productIndex)}
                            title="Ajouter un numéro de lot"
                          >
                            <FaPlusCircle />
                          </button>
                        )}
                        {allocationCount > 1 && (
                          <button
                            type="button"
                            className="text-red-500"
                            onClick={() =>
                              handleRemoveLotAllocation(
                                productIndex,
                                allocationIndex
                              )
                            }
                            title="Supprimer ce lot"
                          >
                            <FaTrash />
                          </button>
                        )}
                      </div>
                    </td>
                    <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                      <select
                        className="flex w-full items-center justify-center rounded-xl border bg-white/0 p-2 text-sm outline-none"
                        disabled={!allocation.lotNumber}
                        onChange={(e) =>
                          handleDepotInputChange(
                            productIndex,
                            allocationIndex,
                            e.target.value
                          )
                        }
                        value={allocation.city || ""}
                      >
                        <option value="">Sélectionner le stock</option>
                        {(() => {
                          if (!allocation.lotNumber) return null;
                          const stockEntry =
                            productLotNumbersData[product.Code]?.find(
                              (entry) =>
                                entry.LotNumber === allocation.lotNumber
                            );
                          if (
                            stockEntry &&
                            stockEntry.ProductDetails &&
                            stockEntry.ProductDetails[0] &&
                            stockEntry.ProductDetails[0].Stock
                          ) {
                            return stockEntry.ProductDetails[0].Stock.map(
                              (stock, stockIndex) => (
                                <option
                                  key={`${stock.City}-${stockIndex}`}
                                  value={stock.City}
                                >
                                  {stock?.City} [{stock?.Disponible}]
                                </option>
                              )
                            );
                          }
                          const fallbackProduct = productStockList.find(
                            (p) => p.Name.trim() === product.productName.trim()
                          );
                          return fallbackProduct?.Stock?.map((stock) => (
                            <option key={stock.City} value={stock.City}>
                              {stock?.City} [{stock?.Disponible}]
                            </option>
                          ));
                        })()}
                      </select>
                    </td>
                    {allocationIndex === 0 && (
                      <td
                        className="pt-[14px] pb-[18px] sm:text-[14px]"
                        rowSpan={allocationCount}
                      >
                        <p className="text-center text-sm font-bold text-navy-700">
                          {product.quantiteByUnity} {product.unity}
                        </p>
                      </td>
                    )}
                    <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                      <input
                        type="number"
                        min={0}
                        placeholder="Quantité"
                        className="flex w-full items-center justify-center rounded-xl border bg-white/0 p-2 text-sm outline-none"
                        onChange={(e) =>
                          handleQuantityInputChange(
                            productIndex,
                            allocationIndex,
                            e.target.value
                          )
                        }
                        value={allocation.inputQuantity ?? ""}
                      />
                    </td>
                    {allocationIndex === 0 && (
                      <td
                        className="pt-[14px] pb-[18px] sm:text-[14px]"
                        rowSpan={allocationCount}
                      >
                        <p
                          className="text-left text-sm font-bold text-navy-700"
                          style={{ position: "relative", left: "2rem" }}
                        >
                          {product.unity}
                        </p>
                        <p
                          className="text-left text-lg font-bold text-navy-700"
                          style={{ position: "relative", top: 10, left: 5 }}
                        >
                          {totalOutput.toFixed(2)}
                        </p>
                      </td>
                    )}
                  </tr>
                ));
              })}
            </tbody>
          )}

          <tfoot>
            <tr>
              <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                <p className="text-center text-sm font-bold text-navy-700"></p>
              </td>
              <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                <p className="text-center text-sm font-bold text-navy-700"></p>
              </td>
              <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                <p className="text-center text-sm font-bold text-navy-700"></p>
              </td>
              <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                <p className="text-center text-sm font-bold text-navy-700"></p>
              </td>
              <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                <p className="text-center text-lg font-bold text-navy-700">
                  Total :
                </p>
              </td>
              <td className="pt-[14px] pb-[18px] sm:text-[14px]">
                <p className="text-center text-lg font-bold text-navy-700">
                  {inputValues
                    .reduce(
                      (sum, product) =>
                        sum +
                        product.allocations.reduce(
                          (allocSum, allocation) =>
                            allocSum +
                            (parseFloat(allocation.inputQuantity) || 0),
                          0
                        ),
                      0
                    )
                    .toFixed(2)}
                </p>
              </td>
            </tr>
          </tfoot>
        </table>

        {
          isLoading ?
          <div className="flex items-center justify-center">
            <Spinner className="h-12 w-12" />
          </div> :
          accessList?.Validation ?
          <Button
            variant="gradient"
            color="#236571"
            className="mr-1"
            onClick={handleStockValidation}
          >
          <span>Valider</span>
          </Button> : null
        }
      </div>
    </div>
  );
}

export default StockInfo;
